export default __webpack_public_path__ + "static/media/Inhaler 1.be56fb24.png";